<template>
  <div v-if="sideWidget" class="add-more-entity d-flex flex-column">
    <div class="d-flex flex-row flex-md-column flex-lg-row">
      <img
        class="image mr-2"
        src="@/assets/images/icons/remittance-add-more-icon.svg"
        alt="Document Icon"
        width="40"
        height="40"
      />
      <div class="drip-h3 color-noble-blue-500">
        {{ heading }}
      </div>
    </div>
    <div class="spacing-4"></div>
    <div class="content">
      <div class="drip-body font-weight-400">
        {{ subtitle }}
      </div>
    </div>
    <div class="spacing-24"></div>
    <div class="button-container">
      <action-button extraClass="w-100" :click="buttonClick">
        {{ buttonText }}
        <b-icon-plus scale="1.2" class="ml-2" />
      </action-button>
    </div>
  </div>
  <div
    v-else
    class="add-more-entity full-width d-flex flex-column justify-content-between"
    :class="{
      'add-border': border
    }"
  >
    <b-row>
      <b-col xs="12" md="8" lg="9">
        <div class="d-flex flex-column justify-content-center">
          <div class="drip-h2 color-noble-blue-500 font-weight-bold">
            {{ heading }}
          </div>
          <div class="drip-h3 color-noble-blue-500 font-weight-400">
            {{ title }}
          </div>
          <div class="drip-body color-noble-blue-500 font-weight-400">
            {{ subtitle }}
          </div>
          <div class="spacing-24"></div>
          <action-button :click="buttonClick" extraClass="w-300">
            {{ buttonText }}
            <b-icon-chevron-right scale="0.8" class="ml-2" />
          </action-button>
        </div>
      </b-col>
      <b-col xs="12" md="4" lg="3">
        <img
          class="image wide-image"
          src="@/assets/images/common/remittance-docs.svg"
          alt="Document Icon"
        />
      </b-col>
    </b-row>
  </div>
</template>
<script>
import ActionButton from '@/components/common/ActionButton'

export default {
  props: [
    'heading',
    'title',
    'subtitle',
    'buttonText',
    'buttonClick',
    'border',
    'sideWidget'
  ],
  components: { ActionButton }
}
</script>
<style lang="scss" scoped>
.add-more-entity {
  background: $sky-blue-50;
  border-radius: 8px;
  padding: 16px;
  .wide-image {
    width: 100%;
    max-width: 200px;
  }
  &.add-border {
    border: 1px solid $sky-blue-400;
  }
  &.full-width {
    padding: 24px;
    background: transparent;
  }
  .content {
    flex-grow: 1;
    line-height: 33px;
    letter-spacing: 0em;
    text-align: left;
    color: $noble-blue-500;
    padding-right: 12px;
    padding-left: 4px;
    :first-child {
      margin-bottom: 2px;
    }
  }
  .button-container {
    width: 100%;
  }
}
</style>
